<template>
  <div class="pc-trade inner-box">
    <bread backTitle="全部数据"></bread>
    <div class="title flex-between">
      <p class="total-trade">
        全部{{ filterNum(pages.total) }}条数据
        <span v-if="pages.total > 100000"> （显示最近10万条）</span>
      </p>
      <page-container
        @pageChange="pageChange"
        @sizeChange="sizeChange"
        :currentPage="pages.number"
        :pageSize="pages.size"
        :total="pages.total > 100000 ? 100000 : pages.total"
      ></page-container>
    </div>
    <!-- 表格部分 -->
    <el-table
      :data="txs.list"
      stripe
      style="width: 100%"
      class="data-table"
      empty-text="暂无数据"
      v-loading="loading && pages.number != 1"
      element-loading-text="拼命加载中..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(255, 255, 255, 0.8)"
      :cell-class-name="groupCellName"
    >
      <el-table-column label width="45" align="center">
        <template v-slot="item">
          <div
            :class="{
              'start-line': item.row.tradeG === 3,
              'middle-line': item.row.tradeG === 1,
              'end-line': item.row.tradeG === 2,
            }"
          >
            <span v-if="item.row.tradeG === 3"></span>
            <i></i>
            <span v-if="item.row.tradeG !== 3"></span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="上链哈希" width="220">
        <template v-slot="item">
          <div>
            <p class="group-title" v-if="item.row.tradeG === 3">数据组</p>
            <router-link
              :to="`/tradeHash?hash=${item.row.hash}`"
              class="light flex-left"
            >
              <i
                class="iconfont err-ico"
                :class="{
                  'iconjinggao-chucuo':
                    item.row.success === false && item.row.is_para === false,
                }"
              ></i>
              {{ filterHash(item.row.hash, 15) }}
            </router-link>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="发送方" align="center">
        <template v-slot="item">
          <router-link
            :to="`/address?address=${item.row.from}`"
            class="light"
            >{{ filterHash(item.row.from, 20) }}</router-link
          >
        </template>
      </el-table-column>
      <el-table-column width="60" align="center">
        <template v-slot>
          <i class="iconfont iconjiantou-you"></i>
        </template>
      </el-table-column>
      <el-table-column label="接收方" align="center">
        <template v-slot="item">
          <router-link :to="`/address?address=${item.row.to}`" class="light">{{
            filterHash(item.row.to, 20)
          }}</router-link>
        </template>
      </el-table-column>
      <el-table-column label="上链时间" width="180" align="center">
        <template v-slot="item">
          <count :time="item.row.block_time"></count>
        </template>
      </el-table-column>
    </el-table>
    <!-- 底部分页 -->
    <div class="bottom-page flex-right">
      <page-container
        @pageChange="pageChange"
        @sizeChange="sizeChange"
        :currentPage="pages.number"
        :pageSize="pages.size"
        :total="pages.total > 100000 ? 100000 : pages.total"
      ></page-container>
    </div>
  </div>
</template>

<script setup>
import { watch, onBeforeUnmount } from "vue";
import Bread from "@/components/computer/Breadcrumb.vue";
import PageContainer from "@/components/computer/PageContainer.vue";
import Count from "@/components/common/Count.vue";
import { filterHash, filterNum } from "@/utils/filters";
import TradeMixins from "@/mixins/trade";
import { groupCellName } from "@/mixins/common";

const { getCount, getTxList, pageChange, sizeChange, pages, loading, txs } =
  TradeMixins();
let Timer = 0;
getCount();
getTxList();
watch(
  () => pages.number,
  (page) => {
    if (page == 1) {
      Timer = window.setInterval(() => {
        getTxList();
        getCount();
      }, 10000);
    } else clearInterval(Timer);
  },
  {
    immediate: true,
  }
);

onBeforeUnmount(() => {
  clearInterval(Timer);
});
</script>

<style lang="scss">
.pc-trade {
  .title {
    margin-top: 20px;
    .total-trade {
      font-size: 14px;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      color: #53657a;
    }
  }
  .data-table {
    margin-top: 15px;
    box-shadow: 0 0.5rem 1.2rem rgba(189, 197, 209, 0.2);
    border-radius: 2px;
    border: 1px solid rgba(235, 239, 241, 1);
    color: $black;
    .err-ico {
      color: #e45359;
      font-size: 12px;
      width: 13px;
      margin-right: 5px;
      display: inline-flex;
    }
    .el-table__header thead tr {
      height: 60px;
    }
    .iconjiantou-you {
      font-size: 20px;
      color: #9aaab9;
    }
    .token-icon {
      height: 26px;
    }
    .tx-start,
    .tx-middle,
    .tx-end {
      background: $group_bg !important;
      .light,
      .iconjiantou-you {
        color: $group_title;
      }
    }
    .tx-start {
      padding-top: 45px;
    }
    .tx-start:nth-of-type(2) {
      padding-top: 0;
    }
    .tx-start:nth-of-type(1),
    .tx-middle:nth-of-type(1),
    .tx-end:nth-of-type(1) {
      padding: 0 0 0 15px;
      text-align: center;
      span {
        background: $group_title;
        width: 5px;
        height: 5px;
        border-radius: 50%;
        display: block;
      }
      i {
        margin: 0 auto;
        display: block;
        width: 1px;
        background: $group_title;
      }
      .start-line {
        position: absolute;
        bottom: 0;
        width: 5px;
        span {
          margin: 0 auto;
        }
        i {
          height: 27.5px;
        }
      }
      .middle-line {
        width: 5px;
        span {
          position: absolute;
          top: 45%;
        }
        i {
          height: 67px;
        }
      }
      .end-line {
        position: absolute;
        top: 0;
        width: 5px;
        span {
          margin: 0 auto;
        }
        i {
          height: 27.5px;
        }
      }
    }
    .group-title {
      margin: 15px 0 9px 20px;
      text-align: left;
      font-size: 14px;
      font-family: PingFangSC-Semibold;
      font-weight: 500;
      color: $group_title;
    }
  }
  .loading-line {
    height: 60px;
    line-height: 18px;
  }
  .bottom-page {
    margin-top: 23px;
  }
  .el-table th:nth-of-type(2) .cell {
    padding-left: 30px;
  }
  .el-loading-mask {
    top: 60px;
  }
}
</style>